import gameIds from '../data/GameIds';

const initialState = {
  versionsByGame: {},
};

const curriculumsReducer = (state = initialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }
  switch (action.type) {
    case 'SET_CURRICULUM_VERSIONS':
      return {
        ...state,
        versionsByGame: action.payload.curriculumVersions,
      };
    default:
      return state;
  }
};

export default curriculumsReducer;
